import { render, staticRenderFns } from "./card-review-gate.vue?vue&type=template&id=7abfed1a"
import script from "./card-review-gate.vue?vue&type=script&lang=js"
export * from "./card-review-gate.vue?vue&type=script&lang=js"
import style0 from "./card-review-gate.vue?vue&type=style&index=0&id=7abfed1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports